import { Inject } from '@angular/core';
import templateSource from './app.component.html';
              import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz');
import { Component, OnInit, OnDestroy, ChangeDetectorRef, enableProdMode } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Service } from "src/libs/portal/season/service";
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

const BROWSER_IDENTITIES = {
    taiko: {
        title: '태고의 달인 서열표',
        icon: '/assets/brand/taigo_icon.png'
    },
    iidx: {
        title: '투덱 서열표',
        icon: '/assets/icon/iidx_icon.png?v=3bca3a28'
    },
    popn: {
        title: '팝픈뮤직 서열표',
        icon: '/assets/brand/taigo_icon.png'
    },
    sdvx: {
        title: 'SOUND VOLTEX 서열표',
        icon: '/assets/brand/taigo_icon.png'
    }
};

@Component({
    selector: 'app-root',
template: templateSource || '',
    styles: [``],
})
export class AppComponent implements OnInit, OnDestroy {
    private routeSubscription?: Subscription;

    constructor(@Inject( Service)         public service: Service,@Inject( Router)         public router: Router,@Inject( ChangeDetectorRef)         public ref: ChangeDetectorRef,@Inject( TranslateService    )         public translate: TranslateService    ) {
        window['MonacoEnvironment'] = {
            getWorkerUrl: function (moduleId: string, label: string) {
                return `/lib/vs/base/worker/workerMain.js`;
            }
        };
    }

    public async ngOnInit() {
        enableProdMode();
        this.updateBrowserIdentity();
        this.routeSubscription = this.router.events.subscribe((event) => {
            if (event instanceof NavigationEnd) {
                this.updateBrowserIdentity(event.urlAfterRedirects || event.url);
            }
        });
        await this.service.init(this);
    }

    public ngOnDestroy() {
        this.routeSubscription?.unsubscribe();
    }

    private updateBrowserIdentity(url?: string) {
        const identity = this.getBrowserIdentity(url);

        document.title = identity.title;
        this.setMetaContent('apple-mobile-web-app-title', identity.title);
        document.querySelectorAll<HTMLLinkElement>('link[rel="shortcut icon"], link[rel="icon"], link[rel="apple-touch-icon"]').forEach((link) => {
            link.href = identity.icon;
        });
    }

    private getBrowserIdentity(url?: string) {
        const routerUrl = String(url || this.router.url || '');
        const source = routerUrl && routerUrl !== '/' ? routerUrl : window.location.pathname;
        const path = source.split(/[?#]/)[0] || window.location.pathname;

        if (path === '/iidx' || path.startsWith('/iidx/')) {
            return BROWSER_IDENTITIES.iidx;
        }

        if (path === '/popn' || path.startsWith('/popn/')) {
            return BROWSER_IDENTITIES.popn;
        }

        if (path === '/sdvx' || path.startsWith('/sdvx/')) {
            return BROWSER_IDENTITIES.sdvx;
        }

        return BROWSER_IDENTITIES.taiko;
    }

    private setMetaContent(name: string, content: string) {
        const meta = document.querySelector<HTMLMetaElement>(`meta[name="${name}"]`);
        if (meta) {
            meta.content = content;
        }
    }
}
